<template>
  <el-dialog
    :title="!dataForm.id ? '新增' : '修改'"
    :close-on-click-modal="false"
    :visible.sync="visible">
    <el-form :model="dataForm" inline :rules="rules" ref="dataForm" label-width="180px">
      <el-form-item label="反馈回复:" prop="answer">
        <el-input type="textarea" v-model="dataForm.answer" placeholder="确认修改/不修改（原因）"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="dataFormSubmit()">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
  export default {
    data () {
      return {
        visible: false,
        dataForm: {
          answer: '',
          answerMan:''
        },
        
      rules: {
          answer:[{ required: true, message: '请输入反馈回复', trigger: 'blur' }]
        },
      }
    },
    watch:{
    },
    computed: {
    },
    methods: {
      init (id) {
        this.dataForm.id = id
        this.visible = true
        this.$nextTick(() => {
          if (this.dataForm.id) {
            this.$http({
              url: this.$http.adornUrl(`course/comment/info/${this.dataForm.id}`),
              method: 'get'
            }).then(({data}) => {
              if (data && data.code === 0) {
                this.dataForm.answer = data.courseComment.toCommentContent
              }
            })
          }
        })
      },
      
      // 表单提交
      dataFormSubmit () {
        this.dataForm.answerMan = JSON.parse(this.$cookie.get("loginUser")).username
        this.$refs['dataForm'].validate((valid) => {
          if (valid) {
            this.$http({
              url: this.$http.adornUrl(`/course/comment/answer`),
              method: `put`,
              data: this.$http.adornData({
                id: this.dataForm.id,
                toCommentContent: this.dataForm.answer,
                toUserName: this.dataForm.answerMan
              })
            }).then(({data}) => {
              if (data && data.code === 0) {
                this.$message({
                  message: '更新成功',
                  type: 'success'
                })
                this.visible = false
                this.$emit('refreshDataList')
              } else {
                this.$message.error(data.msg)
              }
            })
          }
        })
      }
    }
  }
</script>
